import React, {useEffect, useState} from "react";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import { connect } from "react-redux";
import EmployeeForm from "../../forms/EmployeeForm";
import { selectUser } from "../../../redux/auth/selectors";
import {getUser, syncUserCompanies, updateUser} from "../../../services/api/users";
import {ajaxErrorHandler, defaultSuccess} from "../../../libs/utils";
import {withRouter} from "react-router";

const breadcrumbs = [
  {
    title: "Employees",
    to: "/admin/employees"
  }
];

const EmployeesEdit = (props) => {
  const {authUser, match, history} = props;
  const [isUpdating, setUpdating] = useState(false);
  const [user, setUser] = useState();
  const userId = match.params.id;

  useEffect(() => {
    getUser(userId).then(response => {
      setUser(response);
    })
  }, []);

  const handleSubmit = (values) => {
    setUpdating(true);

    const data = {
      firstName: values.firstName,
      companies: { companies: values.companies }
    };

    if (values.email && values.email !== "") {
      data.email = values.email;
    }

    if (values.gender && values.gender !== "") {
      data.gender = values.gender;
    }

    if (values.lastName && values.lastName !== "") {
      data.lastName = values.lastName;
    }

    if (values.size && values.size !== "") {
      data.size = values.size;
    }

    if (values.telephone && values.telephone !== "") {
      data.telephone = values.telephone;
    }

    if (values.nationality && values.nationality !== "") {
      data.nationality = values.nationality;
    }

    if (values.vaccinated && values.vaccinated !== "" && values.vaccinated !== "nochange") {
      data.vaccinated = values.vaccinated === "yes";
    }

    if (values.nationalRegistryNumber && values.nationalRegistryNumber !== "" && values.nationalRegistryNumber.indexOf("XXXXXXXX") === -1) {
      data.nationalRegistryNumber = values.nationalRegistryNumber;
    }

    if (values.dateofbirth && values.dateofbirth !== '') {
      data.birthDate = values.dateofbirth.format('YYYY-MM-DD');
    }

    Promise.all([
      updateUser(userId, data),
      syncUserCompanies(userId, data.companies)
    ]).then(responses => {
      defaultSuccess(`${data.firstName} has been updated!`)
      history.push("/admin/employees");
    }).catch(e => {
      setUpdating(false);
      ajaxErrorHandler(e)
    });
  }

  const handleReloadUser = () => {
    getUser(userId).then((response) => {
      setUser(response);
    });
  };

  return (
      <>
        <AdminSubHeader
            title="Edit User"
            breadcrumbs={breadcrumbs}
        />
        <div className="m-content">
          {user ? (
              <EmployeeForm
                  onSubmit={handleSubmit}
                  authUser={authUser}
                  user={user}
                  formSubmitting={isUpdating}
                  reloadUser={handleReloadUser} // Pass reloadUser function
              />
          ) : (
              <div style={{textAlign: "center"}}>
                <div className="m-loader m-loader--brand" style={{width: "30px", display: "inline-block"}}></div>
              </div>
          )}
        </div>
      </>
  );
}

const mapStateToProps = (state, props) => ({
  authUser: selectUser(state)
});


export default withRouter(connect(mapStateToProps)(EmployeesEdit));
